import { extractProperty } from "./extractProperty"

import { GetComponentQuery } from "apollo"

export function transformHistoryData(historyData: GetComponentQuery) {
  const data = historyData.components?.edges || []
  return data.map((el) => {
    const node = el.node
    const url = node?.url
    const years = extractProperty(node, "years")
    const yearForHomepage = extractProperty(node, "yearForHomePage")
    const title = extractProperty(node, "title")
    const shortText = extractProperty(node, "shortText")
    const imageForDesktop = extractProperty(node, "imageForDesktop")
    const imageForMobil = extractProperty(node, "imageForMobil")
    const desktopImage = extractProperty(node, "desktopImage")
    const subtitle = extractProperty(node, "subtitle")
    const button = extractProperty(node, "button")
    return {
      years,
      title,
      shortText,
      imageForDesktop,
      imageForMobil,
      desktopImage,
      subtitle,
      button,
      url,
      yearForHomepage,
    }
  }) as HistoryData[]
}

export type HistoryData = {
  years: string
  title: string
  shortText: string
  imageForDesktop: string
  imageForMobil: string
  desktopImage: string
  subtitle: string
  url: string
  yearForHomepage?: string
}
